export default __webpack_public_path__ + "static/media/ali_express_transparent.e8dbd797.png";